import clsx from "clsx";
import type { EmployeeTimeEntry } from "@/lib/employeeTimes";
import { normalizeTimesheetStatus } from "@/pages/stundennachweise/timesheetFilterLogic";

export function EmployeeTimeTimesheetBadge({
  entry,
}: {
  entry: Pick<
    EmployeeTimeEntry,
    "timesheet_id" | "timesheet_display_number" | "timesheet_status" | "claimed_hours_decimal"
  >;
}) {
  const label = String(entry.timesheet_display_number || "").trim();
  if (!entry.timesheet_id || !label) return null;

  const status = normalizeTimesheetStatus(entry.timesheet_status || "draft");
  const title =
    entry.claimed_hours_decimal != null
      ? `Übernommen: ${Number(entry.claimed_hours_decimal).toLocaleString("de-DE", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })} h`
      : undefined;

  return (
    <span
      title={title}
      className={clsx("eh-ts-badge", `eh-ts-badge--${status}`)}
    >
      {label}
    </span>
  );
}
